var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTag = function SvgTag(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242E30",
    d: "M7.676 14.939 1.087 8.35l6.38-6.388a1.4 1.4 0 0 1 1.12-.402l5.337.534.534 5.346a1.38 1.38 0 0 1-.394 1.111zM2.942 8.35l4.734 4.734 5.46-5.46-.411-4.332-4.27-.42zm7.683-3.85a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 1h14v14H1z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTag);
export default ForwardRef;